import React, { Component } from 'react'

class Dropdown extends Component {
  constructor (props) {
    super(props)
    this.state = {
      toggled: false
    }
  }
  render () {
    return (
      <a data-tip={this.props.tip} className='box-button pull-left' onClick={() => this.setState({toggled: !this.state.toggled})}><i className={'fa fa-fw ' + this.props.icon} />
        <div className={(this.state.toggled ? 'dropdown-links' : 'hidden')}>
          <ul>
            {this.props.links.map((link, index) => {
              return (
                <a key={'Dropdown_' + index} onClick={link.event}>
                  <li>{link.text}</li>
                </a>
              )
            })}
          </ul>
        </div>
      </a>
    )
  }
}
export default Dropdown



// WEBPACK FOOTER //
// ./src/components/basic/misc/Dropdown.js